import React, { Component } from 'react';
import { compose } from 'recompose';
import { Button, Form, Container, Segment, Dropdown } from 'semantic-ui-react';
import FileUploader from "react-firebase-file-uploader";

import { withFirebase } from '../Firebase';
import { withAuthorization } from '../Session';
import * as ROLES from '../../constants/roles';

const INITIAL_STATE = {
  faultID: '',
  faultDescription: '',
  faultCategory: [],
  faultOutlet: [],
  filenames: [],
  downloadURLs: [],
  isUploading: false,
  uploadProgress: 0
};

class SubmitReportUser extends Component {
  constructor(props) {
    super(props);
 
    this.state = { 
      ...INITIAL_STATE
    };
  }

  onSubmit = event => {
    const { faultID, faultCategory, faultDescription, faultOutlet, filenames } = this.state;
    const dateSubmitted = (new Date()).toLocaleString();
    console.log("here")
    this.props.firebase.doCreateNewFaultReport(dateSubmitted, faultID, faultCategory, faultDescription, faultOutlet, filenames);
    this.setState({ ...INITIAL_STATE });
    event.preventDefault();
    window.location.reload(false);
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleChange = (event, data) => {
    this.setState({
      [data.name]: data.value
    });
  }

  handleUploadStart = () =>
  this.setState({
    isUploading: true,
    uploadProgress: 0
  });

  handleProgress = progress =>
    this.setState({
      uploadProgress: progress
    });

  handleUploadError = error => {
    this.setState({
      isUploading: false
      // Todo: handle error
    });
    console.error(error);
  };

  handleUploadSuccess = async filename => {
    const downloadURL = await this.props.firebase
      .fireStorage()
      .child(filename)
      .getDownloadURL();

    this.setState(oldState => ({
      filenames: [...oldState.filenames, filename],
      downloadURLs: [...oldState.downloadURLs, downloadURL],
      uploadProgress: 100,
      isUploading: false
    }));
  };

  render() {
    const { faultID, faultDescription } = this.state;

    const faultCategory = [
      { key: 'beg', value: 'BBQ Electric Griller || 烧烤炉 (电)', text: 'BBQ Electric Griller || 烧烤炉 (电)' },
      { key: 'bgg', value: 'BBQ Gas Griller || 烧烤炉 (煤气)', text: 'BBQ Gas Griller || 烧烤炉 (煤气)'  },
      { key: 'ac', value: 'Aircon || 冷气', text: 'Aircon || 冷气' },
      { key: 'eac', value: 'Exhaust & Air Cleaner || 抽烟机 与 空气过滤机', text: 'Exhaust & Air Cleaner || 抽烟机 与 空气过滤机' },
      { key: 'el', value: 'Electrical & Lighting || 电与灯事项', text: 'Electrical & Lighting || 电与灯事项' },
      { key: 'ch', value: 'Chiller || 冰箱', text: 'Chiller || 冰箱' },
      { key: 'eq', value: 'Equipment || 器材', text: 'Equipment || 器材' },
      { key: 'si', value: 'Signage || 招牌', text: 'Signage || 招牌' },
      { key: 'fu', value: 'Furniture || 家具', text: 'Furniture || 家具' },
      { key: 'tpc', value: 'Tap, Pipe & Chokage || 水管与阻塞事项', text: 'Tap, Pipe & Chokage || 水管与阻塞事项' },
      { key: 'rs', value: 'Roller Shutter || 铁门', text: 'Roller Shutter || 铁门' },
      { key: 'pc', value: 'Pest Control || 害虫事项', text: 'Pest Control || 害虫事项' },
      { key: 'fe', value: 'Fire Extinguisher || 灭火器', text: 'Fire Extinguisher || 灭火器' },
      { key: 'oth', value: 'Others || 其它', text: 'Others || 其它', selectOnNavigation: true}
    ]

    const faultOutlet = [
      { key: 'sr', value: '1359 Serangoon Road (The Grillery)', text: '1359 Serangoon Road (The Grillery)' },
      { key: 'nb', value: '189 New Bridge Road (Roadside)', text: '189 New Bridge Road (Roadside)'  },
      { key: 'gr', value: '301 Geylang Road (Roadside)', text: '301 Geylang Road (Roadside)' },
      { key: 'amkc', value: 'Ang Mo Kio Central (Roadside)', text: 'Ang Mo Kio Central (Roadside)' },
      { key: 'bm', value: 'Bedok Mall', text: 'Bedok Mall' },
      { key: 'bn', value: 'Bedok North (Roadside)', text: 'Bedok North (Roadside)' },
      { key: 'bv', value: 'Bugis Village', text: 'Bugis Village' },
      { key: 'bpp', value: 'Bukit Panjang Plaza', text: 'Bukit Panjang Plaza' },
      { key: 'cp', value: 'Causeway Point', text: 'Causeway Point' },
      { key: 'te', value: 'Changi Airport Terminal 1, Departure/Transit East', text: 'Changi Airport Terminal 1, Departure/Transit East' },
      { key: 'cih', value: 'Changi Airport Terminal 2, Departure/Check-In Hall (Public Area)', text: 'Changi Airport Terminal 2, Departure/Check-In Hall (Public Area)' },
      { key: 'tn', value: 'Changi Airport Terminal 2, Departure/Transit Lounge North', text: 'Changi Airport Terminal 2, Departure/Transit Lounge North' },
      { key: 'ts', value: 'Changi Airport Terminal 2, Departure/Transit Lounge South', text: 'Changi Airport Terminal 2, Departure/Transit Lounge South' },
      { key: 'cih4', value: 'Changi Airport Terminal 4, Departure/Check-In Hall', text: 'Changi Airport Terminal 4, Departure/Check-In Hall' },
      { key: 'tn4', value: 'Changi Airport Terminal 4, Departure/Transit Lounge North', text: 'Changi Airport Terminal 4, Departure/Transit Lounge North'  },
      { key: 'cc', value: 'Clementi Central (Roadside)', text: 'Clementi Central (Roadside)' },
      { key: 'cm', value: 'Clementi Mall', text: 'Clementi Mall' },
      { key: 'co', value: 'Compass One', text: 'Compass One' },
      { key: 'ecr', value: 'East Coast Road (Roadside)', text: 'East Coast Road (Roadside)' },
      { key: 'gwc', value: 'Great World City', text: 'Great World City' },
      { key: 'hc', value: 'Harbourfront Centre', text: 'Harbourfront Centre' },
      { key: 'hb', value: 'Hotel Boss', text: 'Hotel Boss' },
      { key: 'hm', value: 'Hougang Mall', text: 'Hougang Mall' },
      { key: 'jem', value: 'JEM', text: 'JEM' },
      { key: 'jew', value: 'JEWEL', text: 'JEWEL' },
      { key: 'j8', value: 'Junction 8', text: 'Junction 8' },
      { key: 'jp', value: 'Jurong Point', text: 'Jurong Point' },
      { key: 'l1', value: 'Lot 1 Shopping Mall', text: 'Lot 1 Shopping Mall' },
      { key: 'nex', value: 'NEX', text: 'NEX' },
      { key: 'nc', value: 'Northpoint City', text: 'Northpoint City' },
      { key: 'pag', value: 'Pagoda (Roadside)', text: 'Pagoda (Roadside)' },
      { key: 'par', value: 'Paragon', text: 'Paragon' },
      { key: 'pp', value: 'Parkway Parade', text: 'Parkway Parade' },
      { key: 'plq', value: 'Paya Lebar Quarter', text: 'Paya Lebar Quarter' },
      { key: 'perp', value: 'Peranakan Place', text: 'Peranakan Place' },
      { key: 'rc', value: 'Raffles City Shopping Centre', text: 'Raffles City Shopping Centre' },
      { key: 'rws', value: 'Resorts World Sentosa', text: 'Resorts World Sentosa' },
      { key: 'sa', value: 'Sims Avenue', text: 'Sims Avenue' },
      { key: 'scm', value: 'Suntec City Mall', text: 'Suntec City Mall' },
      { key: 'taka', value: 'Takashimaya', text: 'Takashimaya' },
      { key: 'tc', value: 'Tampines Central', text: 'Tampines Central' },
      { key: 'tm', value: 'Tampines Mall', text: 'Tampines Mall' },
      { key: 'tbp', value: 'Tiong Bahru Plaza', text: 'Tiong Bahru Plaza' },
      { key: 'tpc', value: 'Toa Payoh Central (Roadside)', text: 'Toa Payoh Central (Roadside)' },
      { key: 'vh', value: 'V Hotel', text: 'V Hotel' },
      { key: 'wp', value: 'Waterway Point', text: 'Waterway Point' },
      { key: 'wm', value: 'West Mall', text: 'West Mall' },
      { key: 'ws', value: 'White Sands Shopping Centre', text: 'White Sands Shopping Centre' },
    ]

    const isInvalid = faultCategory === '' || faultDescription === '' || faultOutlet === '';

    return (
    <Container>
      <hr />
          <div class="ui inverted fluid segment">
          <h1>Submit a new Fault Report</h1>
          </div>
      <p></p>

      <Segment>
      <Form size="large" onSubmit={this.onSubmit}>
        <Form.Input
          fluid
          name="faultID"
          value={faultID}
          onChange={this.onChange}
          type="hidden"
          placeholder="Fault ID"
        />    

        <Dropdown
          fluid
          name="faultCategory"
          search 
          selection 
          options={faultCategory}
          onChange={this.handleChange}
          placeholder="Select a Fault Category"
        />

        <p></p>
        {faultCategory !== 'Others || 其它' && (
          <Form.Input
          fluid
          name="faultCategory"
          onChange={this.onChange}
          type="text"
          placeholder="If others, enter a fault category"
          />
        )}

        <p></p>

        <Form.Input
          fluid
          icon="question circle"
          iconPosition="left"
          name="faultDescription"
          value={faultDescription}
          onChange={this.onChange}
          type="text"
          placeholder="Fault Description"
        />

        <Dropdown
          fluid
          name="faultOutlet"
          search 
          selection 
          options={faultOutlet}
          onChange={this.handleChange}
          placeholder="Select an Outlet"
        />

<p></p>

<p class="customFontBlack">(Maximum one image file)</p>

<FileUploader
  accept="image/*"
  name="image-uploader-multiple"
  randomizeFilename
  storageRef={this.props.firebase.fireStorage()}
  onUploadStart={this.handleUploadStart}
  onUploadError={this.handleUploadError}
  onUploadSuccess={this.handleUploadSuccess}
  onProgress={this.handleProgress}
  multiple
/>

<div class="customFontBlack">
  <p></p>
  <p>Progress: {this.state.uploadProgress}%</p>

  <p>Filenames: {this.state.filenames.join(", ")}</p>
</div>
<p></p>

<div>
  {this.state.downloadURLs.map((downloadURL, i) => {
    return <img key={i} src={downloadURL} />;
  })}
</div>
<p></p>
        <Button disabled={isInvalid} color="green" fluid size="large" type="submit">Submit a New Fault Report</Button>
      </Form>
      </Segment>
    </Container>
    );
  }
}

const condition = authUser => authUser && !!authUser.isNewUser === false && !!authUser.roles[ROLES.USER];
 
export default compose(
  withAuthorization(condition),
  withFirebase,
)(SubmitReportUser);